import { interpolate, type LatLon } from './geo';

/** Terrain elevations (m) at n equally spaced points from a to b, via Open-Meteo. null on any failure. */
export async function fetchProfile(a: LatLon, b: LatLon, n = 100, fetchFn: typeof fetch = fetch): Promise<number[] | null> {
  const pts = interpolate(a, b, Math.min(100, Math.max(2, n)));
  const url =
    'https://api.open-meteo.com/v1/elevation?latitude=' +
    pts.map(p => p.lat.toFixed(5)).join(',') +
    '&longitude=' +
    pts.map(p => p.lon.toFixed(5)).join(',');
  try {
    const res = await fetchFn(url);
    if (!res.ok) return null;
    const body = (await res.json()) as { elevation?: unknown };
    const e = body.elevation;
    if (!Array.isArray(e) || e.length !== pts.length || !e.every(v => typeof v === 'number' && Number.isFinite(v))) return null;
    return e as number[];
  } catch {
    return null;
  }
}

/** Points for a profile: one every ~90 m (Copernicus DEM resolution), clamped to 20..60 to stay within the free API quota. */
export function profilePoints(distanceM: number): number {
  return Math.min(60, Math.max(20, Math.ceil(distanceM / 90)));
}
